<div class="outer-container" *ngIf="showAuthenticateMessage">
    <div class="message-container">Press refresh after you authenticate with Dropbox.</div>
    <div class="button-container">
        <button type="button" class="btn" (click)="refreshAfterDropboxAuth()">Refresh</button>
    </div>
</div>

<div class="outer-container" *ngIf="!showAuthenticateMessage">
    <div class="section-title">External Accounts</div>
    <!-- Dropbox -->
    <div class="group-container">
        <div class="group-title"><img src="/assets/img/dropbox-logo.png" />Dropbox</div>
        <div class="message-container" *ngIf="loadingDropbox">
            <i class="fas fa-solid fa-circle-notch fa-spin"></i>
        </div>
        <ng-container *ngIf="!loadingDropbox">
            <div class="details-container"><i class="fas fa-user"></i>{{ contextService.dropboxAccount.email }} (<a (click)="unauthenenticateDropbox()">unlink</a>)</div>
            <div class="details-container"><i class="fas fa-folder"></i>Sync Folder: <span *ngIf="!contextService.client.dropboxExportParentFolderId">None selected</span><span *ngIf="contextService.client.dropboxExportParentFolderId">{{ contextService.client.dropboxExportParentFolderId }}</span> (<a (click)="showDropboxFolderSelector=!showDropboxFolderSelector">choose</a>)</div>

            <div *ngIf="showDropboxFolderSelector" class="folder-select-container">
                <ng-container *ngFor="let folder of dropboxFolders">
                    <div (click)="selectParentFolder(folder.teamFolderId)"><i class="fas fa-angle-down" (click)="expandFolder(folder)"></i> {{ folder.name }}</div>
                </ng-container>
            </div>

            <div class="button-container">
                <button *ngIf="!contextService.dropboxAccount" type="button" class="btn" (click)="authenenticateDropbox()">Login to Dropbox</button>
            </div>
        </ng-container>
    </div>
</div>